<template>
    <div :class="[
        'form-group',
        'form-group--float', {
            'has-error': hasErrors,
            'form-group--active': isNotEmpty,
            'form-group--disabled': disabled,
        }]">
        <input
            class="form-control"
            v-bind="$attrs"
            :name="name"
            :id="name"
            :type="type"
            :value="value"
            :disabled="disabled"
            :required="required"
            @input="onInput" />

        <label v-show="!hideLabel" :for="name" class="control-label">
            <slot>{{ name }}</slot>{{ required ? ' *' : '' }}
        </label>
        <span class="form-group__bar"></span>

        <div v-if="hasErrors" class="form-group__errors">
            <p>{{ errors[0] }}</p>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'SaxxText',
    props: {
        form: {
            required: true,
            type: String,
        },
        name: {
            required: true,
            type: String
        },
        type: {
            required: false,
            type: String,
            default: 'text'
        },
        required: {
          required: false,
          type: Boolean,
          default: false
        },
        validator: {
            required: false,
            type: Function,
            default: () => true,
        },
      hideLabel:{
        required: false,
        type: Boolean,
        default: false
      }
    },
    computed: {
        ...mapGetters('forms', [
            'getField',
            'getErrors',
            'getFieldIsDisabled',
        ]),
        value() {
            return this.getField({
                form: this.form,
                field: this.name,
            });
        },
        errors() {
            return this.getErrors({
                form: this.form,
                field: this.name,
            });
        },
        hasErrors() {
            return this.errors.length > 0;
        },
        isNotEmpty() {
            return (
                String(this.value).length > 0
            );
        },
        disabled() {
            return this.getFieldIsDisabled({ form: this.form, field: this.name });
        },
    },
    methods: {
        ...mapActions('forms', [
            'setField',
        ]),
        onInput(event) {
            const value = event.target.value;
            const prevValue = this.value;
            this.setField({
                form: this.form,
                field: this.name,
                value,
            });

            // Vue needs to be able to detect a change in order to prevent
            // the input from getting out of sync with the store
            if (String(value).trim() !== '' && !this.validator(value)) {
                this.setField({
                  form: this.form,
                  field: this.name,
                  value: prevValue,
              });
            }
        },
    },
}
</script>
